import * as api from "@/api/credittrust";
import { CreditTrustDTO } from "@/api/credittrust/types"; 

export async function getByUuid(
  uuid: string,
  harvestSeason?: string,
  cropType?: string,
): Promise<CreditTrustDTO> {
  try {
    return (await api.getByUuid(uuid!, harvestSeason, cropType)).data;
  } catch (err) {
    switch(err.response?.status) {
      case 404:
        return CreditTrustDTO.generateEmptyWithError('NOT_FOUND');
      default:
        throw err;
    }
  }

}
